const t = {
  name: "UnitedKingdom",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16C12.55 16 13 15.55 13 15C13 14.45 12.55 14 12 14C11.45 14 11 14.45 11 15C11 15.55 11.45 16 12 16Z" fill="currentColor"/>
<path d="M13 3.58582V0H11V3.58582L8 6.58582V10H6V20H8V24H10V20H14V24H16V20H18V10H16V6.58582L13 3.58582ZM16 18H8V12H16V18ZM14 7.41424V10H10V7.41424L12 5.41424L14 7.41424Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as UnitedKingdom
};
